import OldSitePromotionContainer from "components/Site/Promotion/_SitePromotion.container";
import SitePromotionContainer from "components/Site/Promotion/SitePromotion.container";
import { useProductFlags } from "src/hooks/recoil/useProductFlags";
import { useGuardPromotionAccess } from "src/hooks/validation/useGuardPromotionAccess";

// 비 OCI 프로모션 페이지: 생성된 사이트가 있으면 접근을 막고 /console 로 이동
const NonOciSitePromotion = () => {
  const { isBlocked } = useGuardPromotionAccess();
  if (isBlocked) {
    // /console 리다이렉트 진행 중 — 프로모션 화면 노출 방지
    return null;
  }
  return <SitePromotionContainer />;
};

const SitePromotionPage = () => {
  const { isOciProduct } = useProductFlags();
  if (isOciProduct) {
    return <OldSitePromotionContainer />;
  }
  return <NonOciSitePromotion />;
};

export default SitePromotionPage;
